export default __webpack_public_path__ + "static/media/MudSkippers.1cf7b5b3.gif";